<template>
  <div class="distribution-member-bd ub">
    <div class="depatrment-wrap ubv">
      <h1>{{ $t('Common.com_department') }}</h1>
      <div style="padding: 24px 0">
        <search-input width="100%" :placeholder="$t('Common.com_department_name')" v-model="appKey"></search-input>
      </div>
      <div class="ub-f1">
        <custom-tree
          default
          :expand-on-click-node="false"
          v-model="organData"
          :data="organTree"
          node-key="bizId"
          default-expand-all
          :listener="appKey"
          :filterKeys="['bizName']"
          :props="{ label: 'bizName' }"
          @handleNode="handleNodeClick"
        >
          <template slot="label" slot-scope="scope">{{ scope.node.label }}</template>
        </custom-tree>
      </div>
    </div>
    <div style="width: 1px; background: #f0f0f0"></div>
    <div class="memeber-wrap ubv">
      <h1>{{ $t('distribution_member.yuan_gong') }}</h1>
      <div style="padding: 24px 0">
        <search-input width="100%" :placeholder="$t('distribution_member.yuan_gong_xing_ming')" v-model="appKey1" @fetch="getOrganUser"></search-input>
      </div>
      <div class="ub-f1">
        <ul>
          <li :class="[{ cur: userData.bizId === item.bizId }, { auto: item.relationType == 1 }]" v-for="(item, index) in userList" :key="index" @click="handleUserClick(item)" class="ub ub-sp ub-xc">
            <div class="name line1">
              {{ item.userName }}
              <span v-if="item.realName">&ensp;({{ item.realName }})</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div style="width: 1px; background: #f0f0f0"></div>
    <div class="ub-f1 device-wrap ubv">
      <template v-if="`${organData.parentId}` === '0' && !userData.userId">
        <el-tabs v-model="active3">
          <el-tab-pane :label="$t('Common.com_location')" name="location" key="location"></el-tab-pane>
          <el-tab-pane :label="$t('distribution_member.ji_qi')" name="device" key="device"></el-tab-pane>
        </el-tabs>
        <bind-department-item v-if="active3 === 'location'" :organ="organData"></bind-department-item>
        <company-device-item v-if="active3 === 'device'" :organ="organData"></company-device-item>
      </template>
      <template v-else>
        <div class="tab-box" v-if="userData.userId">
          <el-tabs v-model="active">
            <el-tab-pane v-if="funcView.depuser_device_assign" :label="$t('distribution_member.ji_qi_fen_pei')" name="device_location" key="device_location"></el-tab-pane>
            <el-tab-pane v-if="funcView.depuser_loction_list" :label="$t('Common.com_location')" name="location" key="location"></el-tab-pane>
            <el-tab-pane v-if="funcView.depuser_device_list" :label="$t('distribution_member.ji_qi')" name="device" key="device"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="tab-box" v-else>
          <el-tabs v-model="active2">
            <el-tab-pane v-if="funcView.depuser_dep_location_list" :label="$t('Common.com_location')" name="location" key="location"></el-tab-pane>
            <el-tab-pane v-if="funcView.depuser_dep_device_list" :label="$t('distribution_member.ji_qi')" name="device" key="device"></el-tab-pane>
          </el-tabs>
        </div>
        <template v-if="userData.userId">
          <user-device-location v-if="active === 'device_location'" :userId="userData.userId"></user-device-location>
          <bind-location-info v-if="active === 'location'" :userId="userData.userId"></bind-location-info>
          <bind-device-item
            :permission="{ add: funcView.depuser_user_add_device, del: funcView.depuser_user_remove_device }"
            v-if="active === 'device'"
            :organ="organData"
            :user="userData"
          ></bind-device-item>
        </template>
        <template v-else>
          <bind-location-item v-if="active2 === 'location'" :organ="organData" :user="userData"></bind-location-item>
          <bind-device-item
            :permission="{ add: funcView.depuser_dep_add_device, del: funcView.depuser_dep_remove_device }"
            v-if="active2 === 'device'"
            :organ="organData"
            :user="userData"
          ></bind-device-item>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customTree from '@/components/customTree.vue';
import companyDeviceItem from './children/company_device_item.vue';
import bindDeviceItem from './children/bind_device_item.vue';
import bindDepartmentItem from './children/bind_department_item.vue';
import bindLocationItem from './children/bind_location_item.vue';
import bindLocationInfo from './children/bind_location_info.vue';
import userDeviceLocation from './children/user_device_location.vue';

// i18n-lang-component
export default {
  name: 'distribution_member',
  components: { customTree, companyDeviceItem, bindDeviceItem, bindLocationItem, bindLocationInfo, userDeviceLocation, bindDepartmentItem },
  data() {
    return {
      active: '',
      active2: '',
      active3: '',
      appKey: '',
      appKey1: '',
      organData: {},
      organTree: [],
      userData: {},
      userList: [],
    };
  },
  mounted() {
    this.getOrganTree();
    this.getFuncView(null, () => {
      if (this.funcView.depuser_loction_list) {
        this.active = 'device_location';
      } else if (this.funcView.depuser_loction_list) {
        this.active = 'location';
      } else if (this.funcView.depuser_device_list) {
        this.active = 'device';
      }
      if (this.funcView.depuser_dep_location_list) {
        this.active2 = 'location';
      } else if (this.funcView.depuser_dep_device_list) {
        this.active2 = 'device';
      }
    });
    this.active3 = 'location';
  },
  methods: {
    // 获取部门树
    getOrganTree: function () {
      this.$getJSON(apis.DepartmentTree, { isCountDevice: 1 }).then((res) => {
        this.organTree = [res.data];
      });
    },
    // 选中部门
    handleNodeClick: function () {
      this.getOrganUser();
    },
    // 获取部门用户
    getOrganUser: function () {
      this.userData = {};
      this.$getJSON(apis.DepartmentUserPage, {
        search: this.appKey1,
        bizId: this.organData.bizId,
        bizType: this.organData.bizType,
        pageSize: 1000,
        pageNum: 1,
      }).then((res) => {
        this.userList = res.data.list;
        // this.userTotal = res.data.total;
      });
    },
    // 设置为自动或者手动关联
    changeRelationType(data) {
      this.$postJSON(
        apis.DeviceAutomaticUpdate,
        {
          relationType: data.relationType,
          bizId: data.userId,
          bizType: 3,
          toBizId: this.organData.bizId,
          toBizType: this.organData.bizType,
        },
        true
      ).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.handleUserClick(data);
      });
    },
    // 选中用户
    handleUserClick: function (data) {
      this.userData = { ...data };
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.distribution-member-bd {
  background-color: #ffffff;
  height: 750px;
  border-radius: 16px;
  .depatrment-wrap {
    width: 324px;
    padding: 24px;
    & > h1 {
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .memeber-wrap {
    width: 324px;
    padding: 24px;
    & > h1 {
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      font-weight: bold;
    }
    ul > li {
      height: 48px;
      cursor: pointer;
      padding: 0 12px;
      border: 1px solid transparent;
      .name {
        color: $--color-text-regular;
        font-size: 14px;
      }
      &.cur {
        border: 1px solid $--color-primary;
        border-radius: 8px;
        box-sizing: border-box;
        background: #f8f9fa;
        .name {
          color: $--color-primary;
          font-size: 14px;
          font-weight: bold;
        }
      }
      &.auto .el-input__inner {
        background: rgba(179, 179, 179, 0.16);
      }
      .el-input--suffix .el-input__inner {
        padding-right: 24px;
        padding: 0 10px;
        border-radius: 28px;
        line-height: 24px;
      }
      i.el-select__caret {
        font-family: 'icon' !important;
        font-size: 16px;
        width: 20px;
        color: $--color-text-primary;
        &:before {
          content: '\e7f8';
        }
        &:after {
          content: '';
          display: none;
        }
      }
    }
  }
  .device-wrap {
    padding: 24px 24px 0;
  }
}
</style>
